<script setup lang="ts">
import type { Reviews } from '#shared/interfaces/model-grade/reviews'

const { review } = defineProps<{ review: Reviews }>()

const reviewAveragePoint = review.average_rating ?? '0.0'
</script>
<template>
  <div class="review-card shadow-sm rounded">
    <div>
      <div class="review-card-title">
        {{ review.title }}
      </div>
      <hr class="border-line" />
      <div
        class="average-rating-container d-flex flex-row"
        style="margin-top: 7px"
      >
        <div
          class="flex-fill"
          style="height: 25px; display: flex; align-items: center"
        >
          <span class="average-rating-label d-inline-flex">総合評価：</span>
          <span class="average-rating d-inline-flex">{{
            reviewAveragePoint
          }}</span>
          <NuxtRating
            :rating-value="Math.floor(Number(reviewAveragePoint))"
            :read-only="true"
            inactive-color="#E7E9ED"
            active-color="#FFDC4A"
            rating-size="15px"
          />
        </div>
      </div>
      <div
        class="review-container row"
        style="margin-top: 8px; margin-bottom: 8px"
      >
        <div
          class="review-content"
          style="font-size: 12px; word-wrap: break-word; white-space: pre-wrap"
        >
          <span>{{ review.comment.replace(/\\r\\n/g, '\n') }}</span>
        </div>
      </div>
      <div
        class="d-flex"
        style="
          margin: 10px 0 0px 0;
          padding-bottom: 5px;
          display: flex;
          flex-flow: row wrap;
          justify-items: center;
          text-align: center;
        "
      >
        <div class="review-name">{{ review.nickname }}さん</div>
        <div class="review-data">
          {{ review.review_date.replace(/年|月/g, '/').replace('日', '') }}投稿
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.border-line {
  width: calc(100% + 16px);
  margin: 6px 0 6px -8px;
  color: #ecf0f2;
  opacity: 100%;
}

a {
  text-decoration: none;
  color: #333333;
}

div.container {
  background-color: white;
}

.review-data {
  font-size: 11px;
  padding: 3px 0 0 10px;
  opacity: 60%;
}

.review-name {
  font-size: 11px;
  padding: 3px 0 0 0;
  opacity: 60%;
}

.review-card {
  background-color: #ffffff;
  margin-left: 16px;
  margin-right: 16px;
  padding-left: 8px;
  padding-right: 8px;
}

.review-card-title {
  padding-top: 13px;
  font-weight: bold;
  font-size: 15px;
  color: #333333;
}

.average-rating-label {
  font-size: 11px;
  font-weight: bold;
  color: #000000e5;
  line-height: 1.27;
  align-self: center;
  height: 11px;
}

.average-rating {
  font-size: 19px;
  font-weight: bold;
  color: #df2020;
  margin-right: 5px;
}
</style>
